












import {Vue, Component, Prop} from 'vue-property-decorator';
import {FeathersVuexFindAll} from '@/utils';
@Component({
    components: {
    },
})
export default class TierSelector extends Vue {
    @Prop({default: null})
    public value!: any;

    @Prop({default: true})
    public showDescription!: boolean;

    public tiers: any[] = [];
    public mounted() {
        this.loadTiers();
    }
    public created() {
        this.loadTiers();
    }
    public get verticalLayout() {
        return this.isSM(false);
    }
    public async loadTiers() {
        const tiers = await FeathersVuexFindAll(this.$FeathersVuex.Tier, {});
        for (const tier of tiers) {
            tier.image = `/img/tiers/${tier._id}.jpeg`;
        }
        this.tiers = tiers;
    }
    public get tierFontSize() {
        if (this.isXS(null)) { return 0.8; }
        if (this.isSM(null)) { return 1; }
        if (this.isMD(null)) { return 1.1; }
        return 1.2;
    }
    public isSelected(id) {
        return this.value != null && this.value._id === id;
    }
}
